/** Шаги линейки «Создание игр» (холст game). */

export const GAME_CREATION_PATH_SLUG = 'sozdanie_igr';

export const GAME_CREATION_STEPS = [
  {
    id: 'balls',
    title: 'Шарики, клики и мини-игры',
    lead: 'Круги, клики, гравитация и простые мини-игры на холсте.',
    konspekts: [{ slug: 'code-canvas-game', title: 'Конспект' }],
    practiceHref: '/work/canvas-game-01-center-ball',
    practiceLabel: '20 заданий «Холст game: 20 шагов»',
  },
  {
    id: 'play',
    title: 'Клавиши, спрайты и камера',
    lead: 'Герой слушает клавиши, на экране счёт, спрайты и камера.',
    konspekts: [{ slug: 'code-canvas-game-play', title: 'Конспект' }],
    practiceHref: '/work/canvas-play-01-keys-move',
    practiceLabel: '12 заданий «Холст game: управление»',
  },
  {
    id: 'arena',
    title: 'Вид сверху, лабиринты и частицы',
    lead: 'Вид сверху без гравитации, стены, лабиринт и частицы.',
    konspekts: [{ slug: 'code-canvas-game-arena', title: 'Конспект' }],
    practiceHref: '/work/canvas-arena-01-topdown',
    practiceLabel: '10 заданий «Холст game: арена»',
  },
];
